import { IconPDF } from "utils";
import { FileProps } from ".";
import Button from "components/Button";
import { IconDownload, IconFileUpload, IconTrash } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

function singleFileView(props: {
  files: File[];
  uploadedFiles?: FileProps[];
  onRemoveFile?: (file: File) => void;
  onRemoveUploadedFile?: (id: string) => void;
  openFileSelector?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-gray-300 rounded-md flex flex-col items-center p-4">
      <span className="text-gray-500">{IconPDF}</span>
      <div className="text-xs font-medium text-gray-900 mt-3 mb-4">
        {props.uploadedFiles?.length
          ? props.uploadedFiles[0]?.file_name
          : props.files[0]?.name}
      </div>
      <div className="flex gap-2">
        {props.uploadedFiles?.length ? (
          <Button
            type="gray"
            onClick={() => window.open(props.uploadedFiles?.[0].url, "_blank")}
            className="!h-6 !px-2"
            leadingIcon={<IconDownload size={16} stroke={3} />}
            iconClassName="!mr-0.5"
          >
            {t("commons.downloadFile")}
          </Button>
        ) : null}
        <Button
          type="gray"
          onClick={props.openFileSelector}
          className="!h-6 !px-2"
          leadingIcon={<IconFileUpload size={16} stroke={3} />}
          iconClassName="!mr-0.5"
        >
          {t("commons.changeFile")}
        </Button>
        <Button
          type="danger"
          onClick={() =>
            props.uploadedFiles?.length
              ? props.onRemoveUploadedFile?.(props.uploadedFiles[0].file_id)
              : props.onRemoveFile?.(props.files[0])
          }
          className="!h-6 !px-2 bg-red-600 enabled:hover:!bg-red-700 text-white"
          leadingIcon={
            <IconTrash size={16} stroke={3} className="text-white" />
          }
          iconClassName="!mr-0.5"
        >
          {t("commons.removeFile")}
        </Button>
      </div>
    </div>
  );
}

export default singleFileView;
